import React, { useEffect } from 'react';
import { SpinnerComponent } from './SpinnerComponent';
import { ScriptSource } from '../entities/formTemplateDataType';

const DynamicScriptContent = ({scripts}: {scripts: ScriptSource[]}) => {
    const [scriptLoading, setScriptLoading] = React.useState(true);

    useEffect(() => {
        const scriptElements = scripts.map((script, index) => {
            const scriptElement = document.createElement('script');
            scriptElement.src = script.source;
            scriptElement.type = script.type || 'text/javascript';

            if (script.isAsync) {
                scriptElement.async = script.isAsync;
            };

            if (script.isDefer) {
                scriptElement.defer = script.isDefer;
            };

            if (script.attributes?.length > 0) {
                script.attributes.forEach((attr) => {
                    scriptElement.setAttribute(attr.name, attr.value);
                });
            };
            
            if (script.location === 'Head') {
                document.head.appendChild(scriptElement);
            } else if (script.location === 'BodyStart') {
                document.body.prepend(scriptElement);
            } else {
                document.body.appendChild(scriptElement);
            }
            return scriptElement;
        });
        setScriptLoading(false);

        return () => {
            scriptElements.forEach((script, index) => {
                if (scripts[index].location === 'Head') {
                    document.head.removeChild(script);
                } else if (scripts[index].location === 'BodyStart') {
                    document.head.removeChild(script);
                } else {
                    document.body.removeChild(script);
                }
            });
        };
    }, []);

  return (
    <>
      {scriptLoading && <SpinnerComponent isBusy/>}
    </>
  );
};

export default DynamicScriptContent;